import { gql, type OperationVariables } from '@apollo/client';

import GraphQL from '../graphQL';

const query = gql`
mutation updateMySlackUrl($slackUrl: String) {
    updateMySlackUrl(slackUrl: $slackUrl) 
},
`;

export default async function updateMySlackUrl(slackUrl?: string) {
    const variables: OperationVariables = {
        slackUrl: slackUrl || null,
    };
    return GraphQL.mutate<boolean>(query, variables);
}
